import {
  ChevronsLeft,
  ChevronsRight,
  ChevronLeft,
  ChevronRight,
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
} from '@/components/ui/select';

export function DataTablePagination({ table }) {
  return (
    <div className="flex items-center justify-between flex-wrap gap-4 px-2 w-full">
      {/* Left: Page size selector */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2">
        <p className="text-sm font-medium">Rodoma puslapyje</p>
        <Select
          value={`${table.getState().pagination.pageSize}`}
          onValueChange={(value) => {
            table.setPageSize(Number(value));
          }}
        >
          <SelectTrigger className="h-8 w-[70px]">
            <SelectValue placeholder={table.getState().pagination.pageSize} />
          </SelectTrigger>
          <SelectContent side="top">
            {[10, 20, 25, 30, 40, 50].map((pageSize) => (
              <SelectItem key={pageSize} value={`${pageSize}`}>
                {pageSize}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* Right: Pagination controls */}
      <div className="flex items-center space-x-6 lg:space-x-8">
        <div className="flex sm:w-[100px] w-auto items-center sm:justify-center justify-start text-sm font-medium">
          {table.getState().pagination.pageIndex + 1} iš{' '}
          {table.getPageCount() == 0 ? 1 : table.getPageCount()} puslapių
        </div>
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="icon"
            className="sm:size-8 size-8"
            onClick={() => table.previousPage()}
            disabled={!table.getCanPreviousPage()}
          >
            <span className="sr-only">Go to previous page</span>
            <ChevronLeft />
          </Button>
          <span className="text-sm font-medium ml-1">
            {table.getState().pagination.pageIndex + 1}
          </span>
          <Button
            variant="outline"
            size="icon"
            className="sm:size-8 size-8"
            onClick={() => table.nextPage()}
            disabled={!table.getCanNextPage()}
          >
            <span className="sr-only">Go to next page</span>
            <ChevronRight />
          </Button>
        </div>
      </div>
    </div>
  );
}
